import { connect } from 'react-redux';

import PackageInfoBlock from './PackageInfoBlock';
import { cheapestMandatoryTOExtrasSelector } from '../../store/selectors/services';
import { getSimilarPackagesHasAdjustParams } from '../../store/selectors/similar-packages';
import {
  getMeal,
  getMealCode,
  getMealOriginal,
  getOperatorId,
} from '../../store/selectors/package';

const mapStateToProps = (state) => ({
  mandatoryExtras: cheapestMandatoryTOExtrasSelector(state),
  hasAdjustParams: getSimilarPackagesHasAdjustParams(state),
  meal: getMeal(state),
  mealCode: getMealCode(state),
  mealOriginal: getMealOriginal(state),
  operatorId: getOperatorId(state),
});

export default connect(mapStateToProps)(PackageInfoBlock);
